import React, { FC, memo } from 'react';

import { Routes } from 'react-router-dom';
import { initAuthRoutes } from 'routes/routes';
import { renderRoutes } from 'utils/renderRoutes';

const Pages: FC = () => {
  return <Routes>{initAuthRoutes({}).map(renderRoutes)}</Routes>;
};

export default memo(Pages);
